import React from 'react';

import { WarningIcon } from 'assets/icons';

import styles from './ExpiredStep.module.scss';

const ExpiredStep = () => {
  return (
    <div className={styles.expiredStepWrapper}>
      <WarningIcon className={styles.warningIcon} />
      <p className={styles.title}>Time Expired</p>
      <p className={styles.text}>
        You have failed to complete the Knowledge Based Questions within the required time to complete your self-guided
        identity verification. Not to worry—we will review your file internally to finalize your identity verification.
        Please continue completing the remaining sections of your loan portal. As always, feel free to contact us if you
        need any assistance.
      </p>
    </div>
  );
};

export default ExpiredStep;
